<template>
	<AppDialog v-if="seenProductHuntDialog" hideCloseButton disableMaxWidth :dialogName="'installationComplete'" width="790px">
		<div class="dialog-content rounded display-flex flex-row">
			<div class="display-flex flex-column flex-justify-space-between left width-100">
				<div>
					<div class="header-text bold">Have a Product Hunt account?</div>
					<h3 class="mt-2 reg">
						We’re launching soon and would love for you to
						<br />
						join the discussion :)
					</h3>
				</div>
				<div class="display-flex flex-row flex-align-center">
					<AnemicButton @click="onYes" tile class="yes-button pa-0">Yes!</AnemicButton>
					<AnemicButton @click="onNo" tile class="no-button ml-3 pa-0">No</AnemicButton>
				</div>
			</div>
			<div class="right width-100 flex-centerize">
				<v-img :src="ProductHuntCat" />
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { userProductHuntMetadata } from '@/store/modules/auth/getters';
import ProductHuntCat from '@/assets/icons/product-hunt-cat.png';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import AnalyticsService from '@/utils/AnalyticsService';
export default {
	name: 'ProductHuntDialog',
	components: {
		AppDialog,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ userProductHuntMetadata }),
		seenProductHuntDialog() {
			return this.userProductHuntMetadata.seen;
		},
	},
	methods: {
		...mapActions(['saveUserMetadata']),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		onYes() {
			AnalyticsService.sendEvent('HAVE_PH_ACCOUNT', {});
			this.saveUserMetadata({ productHunt: { ...this.userProductHuntMetadata, hasAccount: true } });
			this.close();
		},
		onNo() {
			this.saveUserMetadata({ productHunt: { ...this.userProductHuntMetadata, hasAccount: false } });
			this.close();
		},
	},
	async mounted() {
		await this.saveUserMetadata({ productHunt: { ...this.userProductHuntMetadata, seen: true } });
	},
	data() {
		return { ProductHuntCat };
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 380px;
	background: var(--white);
}

.rounded {
	border-radius: 10px;
}
.left {
	padding: 64px 34px;
}
.right {
	width: 270px;
	padding: 80px 16px;
	background: #f9fafc;
}
.header-text {
	font-size: 25px;
	color: var(--primary-font-color);
}
.footer-button {
	width: 170px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
}
.yes-button {
	@extend .footer-button;
	color: #ffffff !important;
	background: #5858ec !important;
}
.no-button {
	@extend .footer-button;
	color: #5858ec !important;
	background: #ffffff !important;
	border: 1px solid #5858ec !important;
}
</style>
